export const data = {
	data() {
		return {
			headerList: [
				// {
				// 	prop: 'sort',
				// 	label: '排序',
				// 	width: 90,
				// 	sortable: 'custom',
				// 	// align:'center'
				// },
				{
					prop: 'title',
					label: '标题',
					type: 'input',
					requiredTitle: '标题',
					placeHolder: '请输入标题',
					width: 200,
					align:'center'


				},
				{
					prop: 'ptype',
					label: '类型',
					width: 80,

				},
				{
					prop: 'chapterObj',
					label: '章节',
					width: 145
				},
				{
					prop: 'statistics_pv',
					label: 'pv(访问量)',
					width: 110
				}
				
				// {
				// 	prop: 'status',
				// 	label: '状态'
				// },
				// {
				// 	prop: 'created_time',
				// 	label: '创建时间'
				// }
				// {
				// 	prop: 'reason',
				// 	label: '驳回原因/下架原因'
				// },
			]
		}
	}
}